'use client';

import { useActionState } from 'react';
import { submitContactAction } from '@/actions/contact';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { ErrorMessage, SuccessMessage } from '@/components/ui/feedback';

export function ContactForm() {
  const [state, action, pending] = useActionState(submitContactAction, null);

  return (
    <form action={action} className="space-y-4">
      {state?.error && <ErrorMessage>{state.error}</ErrorMessage>}
      {state?.success && <SuccessMessage>{state.success}</SuccessMessage>}
      <Input id="name" name="name" label="Your name" required maxLength={80} />
      <Input id="email" name="email" label="Email" type="email" required maxLength={254} />
      <div>
        <label htmlFor="message" className="block text-sm font-medium text-text-primary">Message</label>
        <textarea
          id="message"
          name="message"
          required
          rows={6}
          maxLength={4000}
          className="mt-1 block w-full rounded-md border border-border bg-surface px-3 py-2 text-sm text-text-primary shadow-sm focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
        />
      </div>
      <Button type="submit" disabled={pending}>
        {pending ? 'Sending…' : 'Send message'}
      </Button>
    </form>
  );
}